import {
  NoteLabel,
  NoteLabelWrapper,
  NoteWrapper,
  NoteLabelCreationDate,
  NoteTextArea,
  Frame,
} from './Note.styled';
import { formatDate } from 'src/utils/dateFns/formatDate';
import { getTimeAM_PM } from 'src/utils/dateFns/formatTime';
import { useContext, useEffect, useRef, useState } from 'react';
import { FileWithinNote } from '../FileAttachment/FileWithinNote';
import { NotesContentProps } from './Notes.types';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { useGetUser } from 'src/tabs/hooks/useGetUser';
import { EMPLOYEE_FEEDBACK_USER } from 'src/tabs/constants/Common.constants';

export const NoteContent = ({ note }: NotesContentProps) => {
  const { month, day, year } = formatDate(new Date(note.createdon));
  const { hour, minutes, am_pm } = getTimeAM_PM(new Date(note.createdon));
  const [displayValue] = useState<string>(note.notetext);
  const containerRef = useRef<HTMLDivElement>(null);
  const { currentUserEmail } = useContext(TeamsFxContext);
  const { user } = useGetUser(currentUserEmail);
  const [noteAuthor, setNoteAuthor] = useState<string>(note.createdby.fullname);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.style.height = 'auto';
      containerRef.current.style.height =
        containerRef.current.scrollHeight + 'px';
    }
    if (user && note.createdby.fullname === EMPLOYEE_FEEDBACK_USER) {
      setNoteAuthor(user?.new_name);
    }
  }, [displayValue, user]);

  let currFile = null;

  if (note.documentbody) {
    const byteCharacters = atob(note.documentbody);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const byteArray = new Uint8Array(byteArrays);
    currFile = new File([byteArray], note.filename, { type: note.mimetype });
  }

  return (
    <NoteWrapper>
      <NoteLabelWrapper>
        <NoteLabel size="medium">{noteAuthor}</NoteLabel>
        <NoteLabelCreationDate size="medium">{`${month}/${day}/${year} at ${hour}:${minutes} ${am_pm}`}</NoteLabelCreationDate>
      </NoteLabelWrapper>
      <Frame>
        <NoteTextArea ref={containerRef} dangerouslySetInnerHTML={{__html: displayValue}} />
        {note.filename && <FileWithinNote file={currFile} annotationID={note.annotationid}/>}
      </Frame>
    </NoteWrapper>
  );
};
